import { render, staticRenderFns } from "./CodeforcesRating.vue?vue&type=template&id=9ecae706&scoped=true"
import script from "./CodeforcesRating.vue?vue&type=script&lang=js"
export * from "./CodeforcesRating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecae706",
  null
  
)

export default component.exports